/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_1c6edaad{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_1c6edaad{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n"}]);
export const root = "root_1c6edaad";
export const item = "item_1c6edaad";